import React from "react";

export const Logo = ({
  className = "",
  textClass = "text-[#0A3B3B]",
  size = "default",
}) => {
  const dim = size === "lg" ? "h-12 w-12" : "h-11 w-11";
  const textSize = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      <img
        src="/shopbook-logo.png"
        alt=""
        aria-hidden="true"
        className={`${dim} -mr-1 block object-contain`}
        loading="eager"
      />
      <span className={`font-display ${textSize} font-bold tracking-tight ${textClass}`}>
        Shopbook
      </span>
    </div>
  );
};

export default Logo;
